import React from 'react'

function Enigma() {
  return (
    <div className='h-screen w-screen bg-black flex gap-5 flex-col justify-center text-xl items-center'>
   <h1 className=' md:text-[2rem] text-white text-center'>Congrats on Finishing Enigma</h1>
   <h2 className=' md:text-[1.5rem] text-white  text-center'>Answer for last question is : GG_3n1gm4!!</h2>
    </div>
  )
}

export default Enigma